/* tslint:disable */

/**
 */
export class RpCardForm {
    from_date?: string;
    to_date?: string;
}
